<template>
  <ExtendedSelectDropdown
    :save-disabled="!allowSave"
    :ok-text="okText"
    :cancel-text="cancelText"
    @apply="$emit('apply')"
    @cancel="$emit('cancel')"
  >
    <template #title>
      {{ title }}
      <span
        v-if="subtitle"
        class="extended-select-dropdown__subtitle"
      >
        {{ subtitle }}
      </span>
    </template>

    <template #all-items>
      <AllItemsBlock
        :active-group-id="activeGroupId"
        :disable-group-select="disableGroupSelect"
        :choices="choices"
        :value="value"
        :select-all-text="selectAllText"
        :select-all-hint="selectAllHint"
        :group-name-text="groupNameText"
        :entity-name-text="entityNameText"
        :select-all-predicate="selectAllPredicate"
        :is-in-modal="isInModal"
        @input="$emit('input', $event)"
        @selectGroup="$emit('selectGroup', $event)"
      />
    </template>

    <template #selected-items>
      <SelectedItemsBlock
        :value="value"
        :items-flat="choicesFlat"
        :format-selected-counter-text="formatSelectedCounterText"
        :error-text="errorText"
        @input="$emit('input', $event)"
      />
    </template>
  </ExtendedSelectDropdown>
</template>

<script>
  import ExtendedSelectDropdown from 'components/Inputs/Select/common/ExtendedSelectDropdown/ExtendedSelectDropdown';
  import SelectedItemsBlock from 'components/Inputs/Select/common/SelectedItemsBlock/SelectedItemsBlock';
  import AllItemsBlock from 'components/Inputs/Select/MultiSelectInput/components/AllItemsBlock/AllItemsBlock';

  export default {
    name: 'MultiSelectDropdown',
    components: {AllItemsBlock, ExtendedSelectDropdown, SelectedItemsBlock},
    props: {
      value: {
        type: Array,
        required: true
      },
      choices: {
        type: Array,
        required: true
      },
      choicesFlat: {
        type: Array,
        required: true
      },
      activeGroupId: {
        type: [Number, String],
        default: null
      },
      title: {
        type: String,
        default: null
      },
      subtitle: {
        type: String,
        default: null
      },
      entityNameText: {
        type: String,
        default: null
      },
      groupNameText: {
        type: String,
        default: ''
      },
      disableGroupSelect: {
        type: Boolean,
        default: false
      },
      formatSelectedCounterText: {
        type: Function,
        default: null
      },
      selectAllText: {
        type: String,
        default: undefined
      },
      selectAllHint: {
        type: String,
        default: null
      },
      selectAllPredicate: {
        type: Function,
        default: () => true
      },
      allowSavePredicate: {
        type: Function,
        default: () => true
      },
      errorText: {
        type: String,
        default: ''
      },
      okText: {
        type: String,
        default: ''
      },
      cancelText: {
        type: String,
        default: ''
      },
      isInModal: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      allowSave () {
        return this.allowSavePredicate(this.value, this.choicesFlat);
      }
    }
  };
</script>
